var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#233737",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3485_17859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66683 18.6668H17.3335C17.6871 18.6668 18.0263 18.5264 18.2763 18.2763C18.5264 18.0263 18.6668 17.6871 18.6668 17.3335V6.66683C18.6668 6.31321 18.5264 5.97407 18.2763 5.72402C18.0263 5.47397 17.6871 5.3335 17.3335 5.3335H9.3335C8.97987 5.3335 8.64074 5.47397 8.39069 5.72402C8.14064 5.97407 8.00016 6.31321 8.00016 6.66683V17.3335C8.00016 17.6871 7.85969 18.0263 7.60964 18.2763C7.35959 18.5264 7.02045 18.6668 6.66683 18.6668ZM6.66683 18.6668C6.31321 18.6668 5.97407 18.5264 5.72402 18.2763C5.47397 18.0263 5.3335 17.6871 5.3335 17.3335V11.3335C5.3335 10.6002 5.9335 10.0002 6.66683 10.0002H8.00016",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 13.3335H10.6665",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 16H10.6665",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 9C10.6665 8.44772 11.1142 8 11.6665 8H14.9998C15.5521 8 15.9998 8.44772 15.9998 9V9.66667C15.9998 10.219 15.5521 10.6667 14.9998 10.6667H11.6665C11.1142 10.6667 10.6665 10.219 10.6665 9.66667V9Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3485_17859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.d3536faf96368a5fbf7bb11941a341f4.svg";
export { ForwardRef as ReactComponent };